module.exports = __webpack_public_path__ + "assets/img/goods_banner.27cc83ae.png";